"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API Documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.WorkspaceStatus = exports.WorkspaceList200ResponseObjectEnum = exports.WorkspaceObjectEnum = exports.TemplateList200ResponseDataInnerObjectEnum = exports.TemplateList200ResponseObjectEnum = exports.ShareLinkType = exports.ShareLinkObjectEnum = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
exports.ShareLinkObjectEnum = {
    ShareLink: 'share_link'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ShareLinkType = {
    Form: 'form'
};
exports.TemplateList200ResponseObjectEnum = {
    List: 'list'
};
exports.TemplateList200ResponseDataInnerObjectEnum = {
    Template: 'template'
};
exports.WorkspaceObjectEnum = {
    Workspace: 'workspace'
};
exports.WorkspaceList200ResponseObjectEnum = {
    List: 'list'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.WorkspaceStatus = {
    Active: 'active',
    Archived: 'archived',
    Error: 'error',
    Provisioning: 'provisioning',
    Created: 'created'
};
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary share_link create
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareLinkCreate: async (body, options = {}) => {
            const localVarPath = `/share_links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary template list
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateList: async (limit, options = {}) => {
            const localVarPath = `/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary workspace create
         * @param {WorkspaceCreatePayload} [workspaceCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceCreate: async (workspaceCreatePayload, options = {}) => {
            const localVarPath = `/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workspaceCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary workspace list
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceList: async (limit, options = {}) => {
            const localVarPath = `/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary workspace retrieve
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceRetrieve: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            (0, common_1.assertParamExists)('workspaceRetrieve', 'workspaceId', workspaceId);
            const localVarPath = `/workspaces/{workspaceId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary share_link create
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shareLinkCreate(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shareLinkCreate(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.shareLinkCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary template list
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async templateList(limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.templateList(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.templateList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary workspace create
         * @param {WorkspaceCreatePayload} [workspaceCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workspaceCreate(workspaceCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workspaceCreate(workspaceCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.workspaceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary workspace list
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workspaceList(limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workspaceList(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.workspaceList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary workspace retrieve
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workspaceRetrieve(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workspaceRetrieve(workspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.workspaceRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         *
         * @summary share_link create
         * @param {DefaultApiShareLinkCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareLinkCreate(requestParameters = {}, options) {
            return localVarFp.shareLinkCreate(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary template list
         * @param {DefaultApiTemplateListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateList(requestParameters = {}, options) {
            return localVarFp.templateList(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary workspace create
         * @param {DefaultApiWorkspaceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceCreate(requestParameters = {}, options) {
            return localVarFp.workspaceCreate(requestParameters.workspaceCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary workspace list
         * @param {DefaultApiWorkspaceListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceList(requestParameters = {}, options) {
            return localVarFp.workspaceList(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary workspace retrieve
         * @param {DefaultApiWorkspaceRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceRetrieve(requestParameters, options) {
            return localVarFp.workspaceRetrieve(requestParameters.workspaceId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     *
     * @summary share_link create
     * @param {DefaultApiShareLinkCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    shareLinkCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).shareLinkCreate(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary template list
     * @param {DefaultApiTemplateListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    templateList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).templateList(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary workspace create
     * @param {DefaultApiWorkspaceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    workspaceCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).workspaceCreate(requestParameters.workspaceCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary workspace list
     * @param {DefaultApiWorkspaceListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    workspaceList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).workspaceList(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary workspace retrieve
     * @param {DefaultApiWorkspaceRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    workspaceRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).workspaceRetrieve(requestParameters.workspaceId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
//# sourceMappingURL=api.js.map